/*
 * Mural Wonder native pricing bridge — DEV STORE PROOF ONLY.
 *
 * Existing mural-cropper.js / mural-cropper.liquid remain unchanged.
 * This bridge only:
 *   1) makes the existing material cards selectable without Apippa; and
 *   2) serializes the confirmed cropper state into _mw_* line properties.
 *
 * It never calculates or authorizes the checkout price. Shopify Functions do.
 */
(function () {
  'use strict';

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'mw-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 14);
  }

  function ensureInput(form, name) {
    var selector = 'input[name="' + name.replace(/"/g, '\\"') + '"]';
    var input = form.querySelector(selector);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    return input;
  }

  function materialFromCard(card) {
    var key = String(card && card.dataset ? card.dataset.mwRateCard || '' : '').toLowerCase();
    if (key === 'washable') return 'Washable';
    if (key === 'peel-stick') return 'Peel & Stick';
    return 'Premium';
  }

  function applyMaterial(cropperRoot, material) {
    var instance = cropperRoot && cropperRoot._mwCropperInstance;
    if (!instance || !instance.state) return;

    material = material === 'Washable' || material === 'Peel & Stick' ? material : 'Premium';

    if (instance.state.material !== material && instance.state.ready &&
        typeof instance.invalidateConfirmation === 'function') {
      instance.invalidateConfirmation('material');
    }

    instance.state.material = material;
    instance.state.rate = instance.rates[material] || instance.rates.Premium || 27;
    instance.state.minimum = instance.minimums[material] || instance.minimums.Premium || 30;

    if (instance.priceLabel) {
      instance.priceLabel.textContent = material + ' · £' + instance.state.rate + ' / m²';
    }

    (instance.rateCards || []).forEach(function (card) {
      var active = materialFromCard(card) === material;
      card.classList.toggle('is-active', active);
      card.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (typeof instance.updatePriceFromInputs === 'function') instance.updatePriceFromInputs();
    if (instance.state.ready && !instance.state.dirty) {
      if (typeof instance.updateSummary === 'function') instance.updateSummary();
      if (typeof instance.schedulePropertiesUpdate === 'function') instance.schedulePropertiesUpdate();
    }
  }

  function makeMaterialCardsInteractive(cropperRoot) {
    var cards = Array.prototype.slice.call(cropperRoot.querySelectorAll('[data-mw-rate-card]'));
    cards.forEach(function (card) {
      if (card.dataset.mwNativeCardBound === 'true') return;
      card.dataset.mwNativeCardBound = 'true';
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-pressed', card.classList.contains('is-active') ? 'true' : 'false');
      card.style.cursor = 'pointer';

      function choose() {
        applyMaterial(cropperRoot, materialFromCard(card));
      }

      card.addEventListener('click', choose);
      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          choose();
        }
      });
    });
  }

  function privatizeLegacyPriceProperties(form) {
    /*
     * The existing cropper keeps these GBP display strings for its own UI.
     * On native-pricing products Shopify's transformed line price is authoritative
     * and currency-aware, so do not expose stale GBP-only descriptive properties
     * in cart/checkout. Keep them on the order as private production metadata.
     */
    var mappings = [
      ['properties[Material price]', 'properties[_Material price]'],
      ['properties[Calculated mural price]', 'properties[_Calculated mural price]']
    ];

    mappings.forEach(function (mapping) {
      var input = form.querySelector('input[name="' + mapping[0].replace(/"/g, '\\"') + '"]');
      if (input) input.name = mapping[1];
    });
  }

  function serializeConfirmedConfiguration(cropperRoot, form, event) {
    var instance = cropperRoot && cropperRoot._mwCropperInstance;
    var state = instance && instance.state;

    /* The existing cropper owns the customer-facing confirmation gate. */
    if (!state || !state.ready || state.dirty || !state.confirmed) return;

    var widthMm = Math.round(Number(state.widthCm) * 10);
    var heightMm = Math.round(Number(state.heightCm) * 10);
    var material = String(state.material || '').trim();

    if (!Number.isSafeInteger(widthMm) || widthMm <= 0 ||
        !Number.isSafeInteger(heightMm) || heightMm <= 0 || !material) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (instance && typeof instance.setMessage === 'function') {
        instance.setMessage(
          'The mural pricing configuration is incomplete. Please reconfirm your wall size and material.',
          'error'
        );
      }
      return;
    }

    privatizeLegacyPriceProperties(form);

    ensureInput(form, 'properties[_mw_width_mm]').value = String(widthMm);
    ensureInput(form, 'properties[_mw_height_mm]').value = String(heightMm);
    ensureInput(form, 'properties[_mw_material]').value = material;
    ensureInput(form, 'properties[_mw_config_id]').value = uuid();
  }

  function attach(productRoot) {
    if (!productRoot || productRoot.dataset.mwNativeBridgeAttached === 'true') return;
    var cropperRoot = productRoot.querySelector('[data-mural-cropper]');
    if (!cropperRoot || !cropperRoot._mwCropperInstance) return;

    var formId = cropperRoot.dataset.formId;
    var form = formId ? document.getElementById(formId) : cropperRoot.closest('form');
    if (!form) return;

    productRoot.dataset.mwNativeBridgeAttached = 'true';
    cropperRoot.dataset.mwNativeBridge = 'connected';

    makeMaterialCardsInteractive(cropperRoot);

    form.addEventListener('submit', function (event) {
      serializeConfirmedConfiguration(cropperRoot, form, event);
    }, true);
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-c67-product-root][data-mw-native-enabled="true"]');
    Array.prototype.forEach.call(roots, function (root) {
      attach(root);
      if (root.dataset.mwNativeBridgeAttached !== 'true') {
        /* Deferred cropper asset normally runs first; one frame retry covers section re-render timing. */
        window.requestAnimationFrame(function () { attach(root); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
